module.exports = __WEBPACK_EXTERNAL_MODULE_class_transformer__;